import React from "react";
import logo from '../../assets/logo-dark.svg';
import videoUrl from '../../assets/video.mp4';



const Home = () => {
    return(
        <>
        <div className="hero-section pt-20 pb-20 bg-center bg-contain">
            <div className="container mx-auto max-w-7xl">
                <div className="">
                    <div className="hero-section-action">
                        <img src={logo} alt="logo" />
                    </div>
                    <div className="hero-section-content">
                        <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">Mine Crypto. Securely. From Your Phone.</h1>
                        <p className="mt-6 text-lg leading-8 text-gray-600">PyramidX lets you mine crypto without draining your battery or data. It’s secure, mobile, and eco-friendly.</p>
                    </div>
                </div>
                <video className="h-full w-full rounded-lg pt-20" autoPlay muted>
                    <source src={videoUrl} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </div>
        </div>

        <div className="marquee flex overflow-hidden py-20">
            <div className="marquee-row flex relative">
                <div className="marquee-item">
                    <h4 className="flex items-center text-5xl font-bold"><span>pX Coin</span><span className="mx-16">*</span></h4>
                </div>
                <div className="marquee-item">
                    <h4 className="flex items-center text-5xl font-bold"><span>Buy coffee ☕</span><span className="mx-16">*</span></h4>
                </div>
                <div className="marquee-item">
                    <h4 className="flex items-center text-5xl font-bold"><span>pX Coin</span><span className="mx-16">*</span></h4>
                </div>
                <div className="marquee-item">
                    <h4 className="flex items-center text-5xl font-bold"><span>Shop for clothes 👗</span><span className="mx-16">*</span></h4>
                </div>
            </div>
            <div className="marquee-row flex">
                <div className="marquee-item">
                    <h4 className="flex items-center text-5xl font-bold"><span>pX Coin</span><span className="mx-16">*</span></h4>
                </div>
                <div className="marquee-item">
                    <h4 className="flex items-center text-5xl font-bold"><span>Book trip ✈️</span><span className="mx-16">*</span></h4>
                </div>
                <div className="marquee-item">
                    <h4 className="flex items-center text-5xl font-bold"><span>pX Coin</span><span className="mx-16">*</span></h4>
                </div>
                <div className="marquee-item">
                    <h4 className="flex items-center text-5xl font-bold"><span>Order food 🍕</span><span className="mx-16">*</span></h4>
                </div>
            </div>
        </div>

        </>
    )
}

export default Home;